import { Drawer, Typography, Button } from 'antd';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { supportedLanguages } from '../../../constants/MarketplaceConstants';
import { updateMarketplaceUserDetails } from '../../../services/API/MarketplaceService';
import '../../../styles/components/MarketPlace/LanguageSelectionDrawer.scss';
import BottomButton from '../../Buttons/BottomButton';

const {Text} = Typography;

function LanguageSelectionDrawer({isLanguageSelectionDrawerVisible, setLanguageSelectionDrawerVisibility}) {
    const [languageList,setLangList] = useState([...supportedLanguages]);
    const {t, i18n} = useTranslation();

    const onLanguageSelect = (key) => {
        const updatedLangList = languageList;

        for (let i=0;i<updatedLangList.length; i++) {
            if (key === updatedLangList[i].key) {
                updatedLangList[i].active = true;
            } else {
                updatedLangList[i].active = false;
            }
        }

        setLangList([...updatedLangList]);
    };

    const updateUserLanguagePreference = (key) => {
        const userId = localStorage.getItem('userId');
        updateMarketplaceUserDetails({
            userId,
            dataToUpdate: {
              preferredLanguage: key
            },
          }).catch(error => {
            console.log(error);
          });
    }

    const setPWALanguage = () => {
        for (let i=0;i<languageList.length; i++) {
            if (languageList[i].active) {
                updateUserLanguagePreference(languageList[i].key);
                i18n.changeLanguage(languageList[i].key);
                setLanguageSelectionDrawerVisibility(false);
                break
            }
        }
    };

  return (
    <div className='drawer-container'>
        <Drawer
            open={isLanguageSelectionDrawerVisible}
            onClose={()=> {setLanguageSelectionDrawerVisibility(false)}}
            key="langSelection"
            placement="bottom"
            closable={false}
            height="auto" 
            >
                <div className='language-selection-container'>
                    <Text className='lang-header-text'>{t('choose_app_language')}</Text>
                    <div className='language-buttons'>
                        {
                            languageList && languageList.length && languageList.map((language)=> {
                                return (
                                    <Button className={language.active ? 'lang-btn active':'lang-btn'} key={language.key} onClick={()=>onLanguageSelect(language.key)}>{language.label}</Button>
                                )
                            })
                        }
                    </div>
                    <BottomButton buttonText={'Update'} callBackFunction={()=>setPWALanguage()}></BottomButton>
                </div>
        </Drawer>
    </div>
  )
}

export default LanguageSelectionDrawer
